import React from "react"
import { useAppContainerContext } from "../appContainer/context"
import { Col } from "react-bootstrap"
import { Container } from "react-bootstrap"
import { useMemo } from "react"


//FIRST COL USED TO HAVE style={showIfAvailable} where showIfAvailable was sometimes empty
//and sometimes was {display: 'none'}

export function PageContent({ children }) {
  const { navi } = useAppContainerContext()
  const [mainWidths, sideWidths] = useMemo(() => {
    const mw = navi ? { xs: 9, lg: 10, xxl: 11 } : { xs: 12 }
    const sw = navi ? { xs: 3, lg: 2, xxl: 1 } : { style: { display: 'none' } }
    return [mw, sw]
  }, [navi])
  // console.log('rendering PageContent', mainWidths, sideWidths, navi)

  // function reportScrollPercentage(per){
  //   if(scrollCallback) scrollCallback(per)
  // }

  return (
    <div className="page-content-container">
      <Col style={{height:'100%'}}
        {...sideWidths}
      >
        <Container fluid className="sidepane-container">
          {navi}
        </Container>
      </Col>
      <Col className="main-content-container"
        {...mainWidths} 
        >
        {children}
      </Col>

    </div>
  )
}